export const GET_CERTIFICATE_INFO = "GET_CERTIFICATE_INFO";
